import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type CustomiseCategoryClasses = 'accordionSummary' | 'accordionContainer';

const customiseCategoryStyles = makeStyles<ISpcTheme, CustomiseCategoryClasses>(
  () => ({
    accordionSummary: {
      borderTop: '1px solid',
      padding: '0',
      '&:last-child': {
        borderBottom: '1px solid',
      },
    },
    accordionContainer: {
      borderBottom: '1px solid',
    },
  }),
  { name: 'Customise_simpleBrands_CustomiseCategory' },
);

export default customiseCategoryStyles;
